import { AfterViewInit, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { WorkshopService } from '../../../_services/_content/workshop.service';
import { IColors, ICustomApp, IWorkshop, IWorkshopRoom, IWSRoom, IWSRoomBBB, IWSRoomLink, NavigationLinkType } from '@sv/interfaces';
import { ShepherdService } from 'angular-shepherd';
import { CustomAppService } from 'src/app/_services/_content/customApp.service';
import { TutorialService } from 'src/app/_services/_tutorial/tutorial.service';
import { NavigationService } from 'src/app/_services/_content/navigation.service';
import { EventAnalyticsService } from 'src/app/_services/_analytics/event-analytics.service';

@Component({
  selector: 'app-workshop-overview',
  templateUrl: './workshop-overview.component.html',
  styleUrls: ['./workshop-overview.component.scss']
})
export class WorkshopOverviewComponent implements OnInit, AfterViewInit, OnDestroy {
  constructor(
    private workshopService: WorkshopService,
    private customAppService: CustomAppService,
    private shepherdService: ShepherdService,
    private tutorialService: TutorialService,
    private navigationService: NavigationService,
    private eventAnalyticsService: EventAnalyticsService
  ) {}

  activeWorkshop: IWorkshop;
  activeRoom: IWorkshopRoom;

  app: ICustomApp;

  colors: IColors;

  mobile = false;
  document: Document = document;
  expanded = -1;
  loaded = false;

  @HostListener('window:resize', [])
  onResize() {
    const width = window.innerWidth;
    this.mobile = width < 699;
  }

  ngOnInit(): void {
    this.mobile = document.documentElement.clientWidth < 699;
    this.customAppService.getCustomAppListener().subscribe((app) => {
      this.app = app;
      this.colors = this.app.colors as IColors;
    });

    // Get selected workshop Module from Service
    this.workshopService.getWorkshopListener().subscribe((workshop) => {
      this.activeWorkshop = workshop;
      this.loaded = true;
    });
  }

  async ngAfterViewInit(): Promise<void> {
    const top = document.getElementById('top');
    if (top) {
      setTimeout(() => {
        top.scrollIntoView();
      }, 1);
    }

    if (sessionStorage.getItem('tutorial') === null && sessionStorage.getItem('workshop') === null) {
      this.shepherdService.addSteps(this.tutorialService.getWorkshopSteps());
      let navigation = this.app.navigation;
      if (typeof navigation === 'string') {
        navigation = await this.navigationService.getNavigationById(navigation);
      }
      this.shepherdService.tourObject.addStep(this.tutorialService.getNextModuleStep(navigation.links, NavigationLinkType.Workshop));

      this.shepherdService.start();
    }
  }

  async ngOnDestroy(): Promise<void> {
    if (sessionStorage.getItem('tutorial') === null) {
      sessionStorage.setItem('workshop', 'false');
      this.shepherdService.complete();
    }
    await this.eventAnalyticsService.newCollectionRoomView();
  }

  switch(room: IWSRoom) {
    if (room === undefined) {
      this.activeRoom = undefined;
      return;
    }
    if (room.workshopTool === 2) {
      window.open((room.settings as IWSRoomLink).link, '_blank');
    } else {
      const settings = room.settings as IWSRoomBBB;
      this.activeRoom = {
        name: room.name,
        password: settings.password,
        id: settings.id,
        adminCodes: settings.adminCodes,
        attendees: settings.attendees,
        hidePresentation: settings.hidePresentation,
        description: room.description,
        imgURL: settings.imgURL,
        splitscreen: settings.splitscreen,
        waitingRoom: settings.waitingRoom
      };
    }
  }
}
